import '../globals';

const prepareYouTubeTracking = function (wrapper) {
    var deferred = $.Deferred(), prepareAttribute = null;
    $.each(wrapper.attributes, function() {
        if (this.name.indexOf('data-gtm-yt') !== -1) {
            prepareAttribute = this.name;
        }
    });

    if (prepareAttribute !== null) {
        $(wrapper).attr(prepareAttribute, '');
    }
    return deferred;
};

const loadYouTubeIframeAPI = function (loadOnce) {
    if ((loadOnce && $('.gtm-api-include').length === 0) || loadOnce === false ) {
        const iframeAPI = document.createElement('script');
        iframeAPI.type = 'text/javascript';
        iframeAPI.src = 'https://www.youtube.com/iframe_api';
        iframeAPI.classList = 'gtm-api-include';
        $('body').append(iframeAPI);
    }
};

/**
 * Initialize the lazy embed overlay
 *
 * @param selector
 */
window.initOverlayLazyEmbed = (selector) => {
    new LazyEmbed({
        elements: selector,
        overlayText: '',
        adoptResponsiveEmbed: true,
        onInit: function (wrapper) {
            const privacyText = wrapper.querySelector('iframe').getAttribute('data-privacy-text');
            wrapper.querySelector('.lazyembed__text').innerHTML = privacyText;
        }
    });
}

(function(PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        new LazyEmbed({
            elements: '[data-lazyembed="video"]',
            overlayText: '',
            adoptResponsiveEmbed: true,
            onClick: function (wrapper) {
                prepareYouTubeTracking(wrapper).done(loadYouTubeIframeAPI(false))
            },
            onInit: function (wrapper) {
                const privacyText = wrapper.querySelector('iframe').getAttribute('data-privacy-text');
                wrapper.querySelector('.lazyembed__text').innerHTML = privacyText;
            }
        });
    });
})(window.PageLoadedQueue);
